import { isLocalDevelopment } from './isLocalDevelopment';

export const LOCAL_DEV_USER_OVERRIDE_HEADER = 'x-tomtom-lab-local-user-ref';

const LOCAL_DEV_USER_OVERRIDE_STORAGE_KEY =
  'tomtom-lab.local-dev-user-override';

/**
 * Users the local switcher always offers. Their roles (administrator, jury
 * member, participant) come from the backend, not from this list.
 */
export const LOCAL_DEV_TEST_USERS = [
  {
    label: 'Alice Smith',
    userRef: 'user:default/alice.smith_tomtom.com',
  },
  {
    label: 'Bob Johnson',
    userRef: 'user:default/bob.johnson_tomtom.com',
  },
  {
    label: 'Charlie Davis',
    userRef: 'user:default/charlie.davis_tomtom.com',
  },
  {
    label: 'Chris Poppe',
    userRef: 'user:default/chris.poppe_tomtom.com',
  },
  {
    label: 'Nathan Gile',
    userRef: 'user:default/nathan.gile_tomtom.com',
  },
  {
    label: 'Jane Doe',
    userRef: 'user:default/jane.doe_tomtom.com',
  },
];

export const getLocalDevUserOverride = (): string | undefined => {
  if (!isLocalDevelopment() || typeof window === 'undefined') {
    return undefined;
  }

  const value = window.sessionStorage
    .getItem(LOCAL_DEV_USER_OVERRIDE_STORAGE_KEY)
    ?.trim();

  return value || undefined;
};

export const setLocalDevUserOverride = (userRef: string): void => {
  if (!isLocalDevelopment() || typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(LOCAL_DEV_USER_OVERRIDE_STORAGE_KEY, userRef);
};

export const clearLocalDevUserOverride = (): void => {
  if (!isLocalDevelopment() || typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.removeItem(LOCAL_DEV_USER_OVERRIDE_STORAGE_KEY);
};

export const getEffectiveUserRef = (actualUserRef?: string): string => {
  if (!isLocalDevelopment()) {
    return actualUserRef ?? '';
  }

  return getLocalDevUserOverride() ?? actualUserRef ?? '';
};

export const getLocalDevUserHeaders = (): Record<string, string> => {
  const userRef = getLocalDevUserOverride();

  if (!isLocalDevelopment() || !userRef) {
    return {};
  }

  return {
    [LOCAL_DEV_USER_OVERRIDE_HEADER]: userRef,
  };
};

const normalizeLocalDevUserPart = (value: string): string => {
  return value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '.')
    .replace(/[^a-z0-9.]/g, '');
};

export const buildLocalDevUserRef = (
  firstName: string,
  familyName: string,
): string => {
  const firstNamePart = normalizeLocalDevUserPart(firstName);
  const familyNamePart = normalizeLocalDevUserPart(familyName);

  if (!firstNamePart || !familyNamePart) {
    return '';
  }
  return `user:default/${firstNamePart}.${familyNamePart}_tomtom.com`;
};
